import './GraphLegend.css';

/**
 * Always-visible small legend explaining the two edge encodings.
 *
 * Ordered so the SEMANTICALLY-LOUDER edge type appears first: thematic
 * connections carry the interesting cross-chapter relationships;
 * same-chapter siblings are quieter context. Encoding is colourblind-
 * safe (dash pattern + weight, not hue alone).
 */
export default function GraphLegend() {
    return (
        <div className="legend" aria-label="Graph legend">
            <ul className="legend__list">
                <li className="legend__item">
                    <svg
                        className="legend__swatch"
                        viewBox="0 0 32 8"
                        aria-hidden="true"
                        focusable="false"
                    >
                        <line x1="1" y1="4" x2="31" y2="4" className="legend__line legend__line--thematic" />
                    </svg>
                    <span>shared theme (thicker = more shared)</span>
                </li>
                <li className="legend__item">
                    <svg
                        className="legend__swatch"
                        viewBox="0 0 32 8"
                        aria-hidden="true"
                        focusable="false"
                    >
                        <line x1="1" y1="4" x2="31" y2="4" className="legend__line legend__line--structural" />
                    </svg>
                    <span>same chapter</span>
                </li>
            </ul>
        </div>
    );
}
